import {
  Component,
  EventEmitter,
  Inject,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from '@boma/ui';
import { BreadCrumbAction, MenuItemAdvanced } from '@boma/client-shared';
import { Router } from '@angular/router';
import { AppComponent } from '../../../../../apps/supplier-portal/src/app/app.component';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'boma-portal-top-bar',
  templateUrl: './portal-top-bar.component.html',
  styleUrls: ['./portal-top-bar.component.scss'],
})
export class PortalTopBarComponent implements OnInit, OnDestroy {
  @Input() topBarNotificationMenuActive;
  @Input() topbarUserMenuActive;
  @Input() customMenuActions;
  @Input() user;
  @Input() organizations;
  @Input() adminportal;

  @Output() handleMenuButtonClick = new EventEmitter();
  @Output() handleSearchClick = new EventEmitter();
  @Output() hanldeTopbarNotificationMenuButtonClick = new EventEmitter();
  @Output() handleTopbarUserMenuButtonClick = new EventEmitter();
  @Output() handleRightMenuClick = new EventEmitter();
  @Output() handleCustomActionClick = new EventEmitter();
  @Output() changeDirectory = new EventEmitter<{
    entityId: string;
    locationId: string;
  }>();

  subscription: Subscription;
  actionSubscription: Subscription;
  disableBackButton = false;

  pages: string[] = [];

  actions: BreadCrumbAction[];
  items: MenuItemAdvanced[];
  selectedOrganizationId = localStorage.getItem('selectedEntityId') || null;
  appMain?: AppComponent;

  menuVisible = false;

  constructor(
    private router: Router,
    private location: Location,
    public breadcrumbService: BreadcrumbService,
    private authService: OAuthService,
    private injector: Injector
  ) {
    this.subscription = breadcrumbService.itemsHandler.subscribe((response) => {
      this.items = response;
      const newUrl = this.location.path();
      this.pages.push(this.location.path());
      if (
        this.pages.length > 1 &&
        this.pages[this.pages.length - 1] === this.pages[this.pages.length - 2]
      )
        this.pages.pop();
    });
    this.actionSubscription = breadcrumbService.actionHandler.subscribe(
      (response) => {
        this.actions = response;
      }
    );
  }

  ngOnInit(): void {
    if (!this.selectedOrganizationId && this.organizations?.length > 0) {
      this.selectedOrganizationId = this.organizations[0].id; // zero might not be defined find a better way.
      this.changeDirectory.emit({
        entityId: this.selectedOrganizationId,
        locationId: null,
      });
    }
    if (this.adminportal !== true) {
      this.appMain = <AppComponent>this.injector.get(AppComponent);
    }
  }

  logout() {
    this.authService.logOut();
    this.router.navigate(['/']);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.actionSubscription?.unsubscribe();
  }

  handleEntityOptionChanged(id) {
    this.changeDirectory.emit(id);
  }

  handleDropdown(event) {
    this.router.navigate([event.value.url]);
  }

  stepBack() {
    this.pages.pop();
    const lastPage = this.pages.pop(); // get the page we want to go to
    if (lastPage) this.router.navigate([lastPage]); // go there
  }

  toggleMenu() {
    this.menuVisible = !this.menuVisible;
  }
}
